import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    students: [],
    studentProfile: null,
}

const studentSlice = createSlice({
    name: "student",
    initialState,
    reducers: {
        setStudent: (state, action) => {
            state.students = action.payload;
        },

        setStudentProfile: (state, action) => {
            state.studentProfile = action.payload;
        }
    }
});

export const { setStudent, updateStudent, setStudentProfile } = studentSlice.actions;
export default studentSlice.reducer;